// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1tU9v","list":"BalanceDue_list__28VVD","listRow":"BalanceDue_listRow__2Gugw","total":"BalanceDue_total__lm5Oo"};